import { Component, ErrorInfo, ReactNode } from "react";
import Status500 from "src/content/pages/Status/Status500";
interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: string;
  errorDetail: string;
  cause?: any;
  name?: string;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: "",
      errorDetail: ""
    };
    // window.onunhandledrejection = (error: PromiseRejectionEvent) => {
    //   this.setState({
    //     ...this.state,
    //     hasError: true,
    //     error: error.reason.message,
    //     errorDetail: error.reason.stack,
    //   })
    // }
  }

  static getDerivedStateFromError(err: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: err.message, errorDetail: err.stack };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      ...this.state,
      error: error.message,
      errorDetail: error.stack,
      name: error.name
    })
  }
  render() {
    if (this.state.hasError) {
      return <Status500
        error={this.state.error}
        errorDetail={this.state.errorDetail}
      />
    }
    return this.props.children
  }
}

export default ErrorBoundary;